
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Users, FileText, UserCheck, TrendingUp } from 'lucide-react';
import { useExpertApplications } from '@/hooks/useExpertApplications';
import { usePublishedExperts } from '@/hooks/usePublishedExperts';

export default function AdminStats() {
  const { applications, loading: applicationsLoading } = useExpertApplications();
  const { publishedExperts, loading: expertsLoading } = usePublishedExperts();

  const stats = [
    {
      title: 'Total Applications',
      value: applicationsLoading ? '...' : applications.length,
      icon: FileText,
      color: 'bg-blue-500'
    },
    {
      title: 'Pending Review',
      value: applicationsLoading ? '...' : applications.filter(app => app.status === 'pending').length,
      icon: UserCheck,
      color: 'bg-yellow-500'
    },
    {
      title: 'Published Experts',
      value: expertsLoading ? '...' : publishedExperts.filter(expert => expert.status === 'active').length,
      icon: Users,
      color: 'bg-green-500'
    },
    {
      title: 'Approved Today',
      value: applicationsLoading ? '...' : applications.filter(app => 
        app.status === 'approved' && 
        new Date(app.updated_at).toDateString() === new Date().toDateString()
      ).length,
      icon: TrendingUp,
      color: 'bg-purple-500'
    }
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4 mb-8">
      {stats.map((stat) => {
        const Icon = stat.icon;
        return (
          <Card key={stat.title}>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">
                {stat.title}
              </CardTitle>
              <div className={`p-2 rounded-md ${stat.color}`}>
                <Icon className="h-4 w-4 text-white" />
              </div>
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">{stat.value}</div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
